import { errorSchema } from '@shared/schema/errorSchema.js';

const getErrorSchema = ({ httpStatus, code, admin, stepWithOrphanedCredentials }) => {
  const schema = errorSchema[code] || errorSchema[httpStatus] || errorSchema.DEFAULT;
  const roleSchema = admin ? schema.roles?.admin : null;
  return {
    ...schema,
    ...roleSchema,
    ...(admin ? { stepWithOrphanedCredentials } : {})
  };
};

export default getErrorSchema;
